import { h, Fragment, cn, type VNode } from '../../../lib/vdom.js';

export type IconCardData = { icon: VNode; heading: string; desc: VNode };

export default function IconCardGrid(props: { children?: VNode; blue?: boolean; green?: boolean }) {
  return <div className={cn('icon-card-grid', props.blue && 'blue', props.green && 'green')}>{props.children}</div>;
}

export function IconCard(props: { heading: VNode; icon: VNode; children?: VNode }) {
  return (
    <div className="icon-card">
      {props.icon}
      <div>
        <h2>{props.heading}</h2>
        {props.children}
      </div>
    </div>
  );
}

IconCard.Desc = function IconCardDesc(props: { children?: VNode }) {
  return <p className="desc">{props.children}</p>;
};

IconCard.Footer = function IconCardFooter(props: { children?: VNode }) {
  return <p className="footer">{props.children}</p>;
};
